module.exports = __webpack_public_path__ + "static/media/saccades.036a28bf.png";